import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "./Card";
import SectionMetaChip from "./SectionMetaChip";

const SectionCard = ({
  section = "",
  subtitle = "",
  heading = "",
  description = "",
  descriptionMarginBottom = "20px",
  id,
  children,
}) => (
  <Box id={id}>
    <Card section={section}>
      {subtitle ? (
        <SectionMetaChip
          label={subtitle}
          sx={{
            marginTop: "-8px",
            marginBottom: heading || description ? "8px" : "20px",
          }}
        />
      ) : null}
      {heading ? (
        <Typography
          component="h2"
          sx={{
            fontSize: "18px",
            fontWeight: 800,
            color: "text.primary",
            letterSpacing: "-0.3px",
            lineHeight: 1.3,
            marginBottom: description ? "5px" : "20px",
          }}
        >
          {heading}
        </Typography>
      ) : null}
      {description ? (
        <Typography
          sx={{
            fontSize: "13px",
            color: "text.secondary",
            lineHeight: 1.6,
            marginBottom: descriptionMarginBottom,
          }}
        >
          {description}
        </Typography>
      ) : null}
      {children}
    </Card>
  </Box>
);

export default SectionCard;
